export function useCalendarAPI() {
  const { errors, request } = useRequest();

  async function getCalendarEvents(requestBody: GetCalendarEventsRequestDTO) {
    const url = versionedUrl('Planning/GetCalendarEvents');

    const response = await request<CalendarEventsListContainerDTO>(url, {
      method: 'POST',
      body: requestBody
    });

    return response;
  }

  async function deleteCalendarEvent(requestBody: DeleteCalendarEventRequestDTO) {
    const url = versionedUrl('Planning/Delete');

    const response = await request(url, {
      method: 'POST',
      body: requestBody
    });

    return response;
  }

  async function saveCalendarEvent(event: UpsertCalendarEvent) {
    const method = event.ID === undefined ? 'CreateIonic' : 'UpdateIonic';
    const url = versionedUrl(`Planning/${method}`);

    const response = await request<CalendarEventsListContainerDTO>(url, {
      method: 'POST',
      body: event
    });

    return response;
  }

  async function saveManyCalendarEvent(event: CreateManyCalendarEventsRequestDTO) {
    const url = versionedUrl('Planning/IonicCreateMany');

    const response = await request<CalendarEventsListContainerDTO>(url, {
      method: 'POST',
      body: event
    });

    return response;
  }

  async function getEventCategories() {
    const url = versionedUrl('Planning/GetAllCalendarEventCategories');
    const response = await request<CalendarEventCategoryDTO[]>(url, {
      method: 'GET'
    });

    return response;
  }

  async function getResourceGroups() {
    const url = versionedUrl('Planning/GetResourceGroups');
    const response = await request<ResourceGroupDTO[]>(url, {
      method: 'GET'
    });

    return response;
  }

  async function checkAvailability(requestBody: CheckAvailabilityRequestDTO) {
    const url = versionedUrl('Planning/CheckAvailability');

    const response = await request<CheckAvailabilityResponseDTO>(url, {
      method: 'POST',
      body: requestBody
    });

    return response;
  }

  async function GetById(id: number) {
    const url = `${versionedUrl('Planning/GetByID')}/${id}`;

    const response = await request<CalendarEventListItemDTO>(url, {
      method: 'GET'
    });

    return response;
  }

  return {
    errors,
    saveManyCalendarEvent,
    checkAvailability,
    getCalendarEvents,
    saveCalendarEvent,
    getEventCategories,
    deleteCalendarEvent,
    getResourceGroups,
    GetById
  };
}
